import { memo } from "react";

import { Button } from "@react/components/Button";
import { Heading } from "@react/components/Heading";
import { SegmentedControl } from "@react/components/SegmentedControl";
import { Text } from "@react/components/Text";
import { tw } from "classnames";

type Props = {
  label: string;
  labelCtaText?: string;
  linkAriaLabel?: string;
  onLabelCtaClick?: () => void;
  options?: { label: string; to: string; type: "link" }[];
  selectedIndex: number;
  selectedOption?: string;
};

const styles = {
  base: tw("w-full", "flex", "flex-col", "gap-y-2"),
  header: {
    details: tw("flex", "items-baseline", "gap-2", "flex-1", "text-primary"),
    detailsText: tw("text-primary-muted", "flex-1"),
  },
};

const ProductBridgeViewBase = ({
  label,
  labelCtaText,
  linkAriaLabel,
  onLabelCtaClick,
  options,
  selectedIndex,
  selectedOption,
}: Props) => {
  return (
    <div className={styles.base}>
      <legend className="sr-only">{label} options</legend>
      <div className={styles.header.details}>
        <Heading as="h6">{label}:</Heading>
        <div className={styles.header.detailsText}>
          <Text as="body2">{selectedOption}</Text>
        </div>
        {!!(labelCtaText && onLabelCtaClick) && (
          <Button onClick={onLabelCtaClick} type="link">
            {labelCtaText}
          </Button>
        )}
      </div>
      {options && (
        <SegmentedControl
          linkAriaLabel={linkAriaLabel}
          options={options}
          selectedIndex={selectedIndex}
        />
      )}
    </div>
  );
};

export const ProductBridgeView = memo(ProductBridgeViewBase);
